import './attributesList.scss';
import {$Keys} from 'utility-types';
import React from 'react';
import {ProdDocument} from '../../../../../search-types';
import {useSelectedDocContext} from '../../../../../search-hooks';
import {useTranslation} from 'react-i18next';
import {Checkbox} from '../../../../../../common/checkbox/checkbox';
import {Translations} from '../../../../../../backendTranslations/backendTranslations-types';
import {useSelector} from 'react-redux';

type AttributesListProps = {
    attributes: Array<$Keys<ProdDocument>>;
};

export const AttributesList = React.memo(({attributes}: AttributesListProps) => {
    const {t} = useTranslation();
    const selectedDoc = useSelectedDocContext();
    const translations: Translations = useSelector((state) => state.translations);

    if (!selectedDoc) {
        return null;
    }

    const getRenderedValue = (attribute: string) => {
        const attrValue = selectedDoc[attribute];
        if (attribute === 'contentSource' && attrValue.startsWith('http')) {
            return selectedDoc.title;
        }
        if (typeof selectedDoc[attribute] === 'boolean') {
            return <Checkbox mayEdit={false} value={selectedDoc[attribute] || false}/>;
        }
        if (Array.isArray(attrValue)) {
            return attrValue.join(', ');
        }
        const translatedValue = translations.translations?.[attribute]?.[attrValue];
        return translatedValue ? translatedValue : attrValue;
    };

    return (
        <div className="document-attribute-list">
            {attributes
                .filter((key: string) => selectedDoc[key] !== undefined)
                .map((attr) => (
                    <div key={attr} className="document-attribute">
                        <div className="attribute-name cell">{t('attributes.' + attr)}</div>
                        <div className="attribute-value cell">
                            <span>{getRenderedValue(attr)}</span>
                        </div>
                    </div>
                ))}
        </div>
    );
});
